// extracted by mini-css-extract-plugin
export default {"item":"crickettimes_item__+7mKm"};